import React from "react";
import { AgencyAccountDetails } from "./AgencyAccountDetails";
import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import SingleSelectAutocomplete from "../../components/AutoComplete/AutoComplete";
import FormInput from "../../components/GeneralComponents/FormInput";

export const AgencyAccountDetailsModal = ({
  rowData,
  setRowData,
  handleSubmit,
  setEmployeeStatus,
  employeestatus,
  Data,
  setEmployee,
  employee,
  setEmployeeArray,
  employeeArray,
  setData,
  setUserList,
  userList,
}) => {
  return (
    <div className="">
      <h5>Account Details</h5>
      <form onSubmit={handleSubmit}>
        <div className="card_modal ">
          <AgencyAccountDetails
            rowData={rowData}
            setRowData={setRowData}
            setUserList={setUserList}
            userList={userList}
          />
          <>
            <div className="my-3 text-start">
              <FormControl fullWidth required>
                <InputLabel>Status</InputLabel>
                <Select
                  label="Status"
                  value={employeestatus?.name || null}
                  onChange={(event) =>
                    setEmployeeStatus({
                      name: event.target.value,
                    })
                  }
                  name="status"
                >
                  <MenuItem value={"Review"}>Review</MenuItem>
                  <MenuItem value={"Needs Changes"}>Needs Changes</MenuItem>
                  <MenuItem value={"Approved"}>Approved</MenuItem>
                  <MenuItem value={"Rejected"}>Rejected</MenuItem>
                </Select>
              </FormControl>
            </div>
            {employeestatus?.name === "Approved" && (
              <div className="mt-3">
                <SingleSelectAutocomplete
                  inputLabel="Assign Business Center"
                  selectedOption={employee}
                  setSelectedOption={setEmployee}
                  optionsList={employeeArray}
                  required={true}
                  name="name"
                  size="medium"
                />
              </div>
            )}
          </>
          {employeestatus?.name == "Needs Changes" ||
          employeestatus?.name == "Approved" ||
          employeestatus?.name == "Rejected" ? (
            <div className="mt-3">
              <FormInput
                label={employeestatus?.name + " " + "Message"}
                name="address"
                type="text"
                multline={true}
                value={Data.address}
                onChange={(e) => setData({ ...Data, address: e.target.value })}
              />
            </div>
          ) : (
            ""
          )}
          <div className="col-12 text-end mt-3">
            <Button
              variant="contained"
              className="ms-3"
              type="submit"
              disabled={!employeestatus?.name && !Data?.address}
            >
              Submit
            </Button>
          </div>
        </div>
      </form>
    </div>
  );
};
